import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import ImageOutlined from '@mui/icons-material/ImageOutlined';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import TableChartOutlined from '@mui/icons-material/TableChartOutlined';

/** A small icon for the kind of file: PDF red, spreadsheet green, Word blue */
export function FileIcon({ ext }: { ext: string }) {
  if (ext === 'pdf') return <PictureAsPdfOutlined color="error" />;
  if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') return <TableChartOutlined color="success" />;
  if (ext === 'docx' || ext === 'doc') return <DescriptionOutlined color="primary" />;
  if (['jpg', 'jpeg', 'png', 'heic'].includes(ext)) return <ImageOutlined color="action" />;
  return <InsertDriveFileOutlined color="action" />;
}
